<div class="select">
  <label [id]="labelId">
    <span *ngIf="key === 'period'">Kreditdauer</span>
    <span *ngIf="key === 'protectionData'">Kreditschutz</span>
  </label>
  <div
    class="select__selected"
    role="combobox"
    [attr.aria-labelledby]="labelId"
    [attr.aria-expanded]="openOptions"
    [attr.aria-haspopup]="'listbox'"
    tabindex="0"
    (click)="openOption()"
    (keydown)="onKeydown($event)"
  >
    <p>{{ selectValue }}</p>
    <i
      class="arrow"
      [class]="openOptions ? 'up' : 'down'"
      aria-hidden="true"
    ></i>
  </div>
  <div
    class="select__list"
    *ngIf="openOptions"
    role="listbox"
    [attr.aria-labelledby]="labelId"
  >
    <ng-container *ngFor="let option of selectData; let i = index; trackBy: trackByOption">
      <div
        class="list__option"
        role="option"
        [attr.id]="getOptionId(i)"
        [attr.aria-selected]="selectValue === option.name"
        [attr.data-option]="option.option"
        (click)="onChange(option)"
        (keydown)="onOptionKeydown($event, option, i)"
        tabindex="-1"
      >
        <p class="option__main">{{ option.name }}</p>
      </div>
    </ng-container>
  </div>
</div>
